import { render } from "./billingHistoryTransactionTable.vue?vue&type=template&id=0b00426e"
import script from "./billingHistoryTransactionTable.vue?vue&type=script&lang=js"
export * from "./billingHistoryTransactionTable.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__